import type { Item } from '@bc/discovery/ui/filters';
import { filterIconConfig } from '@client/modules/discovery/feature/catalog/components/filter-sidebar/filter-icon-config';
import { filterFeatureFlagConfig } from '@bc/discovery/feature/catalog/components/filter-sidebar/filter-feature-flag-config';

export const enrichItemsWithIconConfig = (items: Item[]): Item[] =>
  items
    .filter((item) => (item.value in filterFeatureFlagConfig ? filterFeatureFlagConfig[item.value](item) : true))
    .map((item) => {
      const iconConfig = filterIconConfig[item.value];
      if (!iconConfig) {
        return item;
      }
      return { ...item, iconConfig };
    });
